// extracted by mini-css-extract-plugin
export default {"availability":"availability_gyL7Q","dot":"dot_siVlw"};